import services from '@/services'

import * as types from './mutations-types'

export const createTicket = context =>
  services.ticket.createTicket(context.getters.chatKey)

export const setContactMessageSent = (context, value) =>
  context.commit(types.SET_MESSAGE_SENT, value)
